import path from 'path';
import {Users} from '@packages/systems/users/plugins';
import {
  PAGE_UTIL_KEYS,
  PageUtilKeys,
} from '@packages/domains/designer-workspace/page-management/data-types';
import {Plugins} from '@packages/systems/wfdl';

export const plugin = Plugins.PrivilegedPlugin({
  ...Users,
  /**
   * The type cast is needed because the icons from Users include
   * ForwardRefExoticComponent types (coming from e.g. the wrapAddPanelIcon function),
   * which are not strictly compatible with the expected ComponentType<IconProps>.
   * TODO: Adjust the icons types PrivilegedPluginType to fix the root cause of this type incompatibility.
   */
  icons: Users.icons as Plugins.PrivilegedPluginType['icons'],
  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-usys.js')],
      bundleIf: {
        type: 'site',
        test: (siteJson) => {
          const {pages = []} = siteJson;
          return (
            pages.filter(
              (page: {utilKey?: PageUtilKeys}) =>
                page.utilKey && PAGE_UTIL_KEYS.includes(page.utilKey)
            ).length > 0
          );
        },
      },
    },
    {
      filePaths: [path.resolve(__dirname, 'webflow-usys-form.js')],
      bundleIf: {
        type: 'node',
        test: (node) =>
          node.type === 'UserAccountForm' || node.type === 'UserSignUpForm',
      },
    },
  ],
});
